<template>
  <el-dialog
    v-model="abierto"
    title="Diagrama de flujo de procesos"
    width="82%"
    top="4vh"
    append-to-body
    destroy-on-close
  >
    <div
      v-if="!procesos.length"
      class="flujo-vacio"
    >
      El elemento todavía no tiene procesos para diagramar.
    </div>
    <template v-else>
      <procesos-flujo-diagrama :procesos="procesos" />
      <p class="flujo-hint">
        Sólo lectura. Arrastrá el lienzo para desplazarte y usá la rueda del mouse para el zoom. Las
        flechas sólidas <em>«material»</em> indican de qué proceso proviene un material cargado en
        el proceso destino. Las flechas punteadas <em>«por orden»</em> son la precedencia implícita:
        todo proceso toma como precedente al anterior por orden además de sus orígenes de material,
        salvo que esté marcado como «Proceso inicial».
      </p>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  computed,
  defineAsyncComponent,
  h,
} from 'vue';

const props = defineProps({
  visible: { type: Boolean, default: false },
  /** Lista aplanada de procesos (ver aplanarProcesosParaPrecedentes). */
  procesos: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:visible']);

const abierto = computed({
  get: () => props.visible,
  set: (valor) => emit('update:visible', valor),
});

// Lazy: Vue Flow + dagre + su CSS sólo se cargan al abrir el modal. Si faltara la dependencia
// (no se corrió `npm i`), sólo falla el diagrama, no el resto de la app.
const ProcesosFlujoDiagrama = defineAsyncComponent({
  loader: () => import('./procesos_flujo_diagrama.vue'),
  loadingComponent: {
    render: () => h('div', { class: 'flujo-vacio' }, 'Cargando diagrama…'),
  },
  errorComponent: {
    render: () =>
      h(
        'div',
        { class: 'flujo-vacio' },
        'No se pudo cargar el diagrama. Instalá las dependencias: @vue-flow/core, @vue-flow/background, @vue-flow/controls, @dagrejs/dagre.',
      ),
  },
  timeout: 8000,
});
</script>

<style scoped>
.flujo-vacio {
  padding: 40px 0;
  text-align: center;
  color: var(--el-text-color-secondary);
  font-style: italic;
}

.flujo-hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: var(--el-text-color-secondary);
}
</style>
